import { todayNYearsAgo, lastNDate } from '@bingads-webui-universal/primitive-utilities';
import { DatePicker } from '@bingads-webui/date-picker';
import { PureKnockoutView } from '@bingads-webui/knockout-view';
import template from './template.pug';
import { RuleCronSelectionviewModel } from './viewmodel';

export class RuleCronSelectionview extends PureKnockoutView {
  initialize({
    i18n,
    permissions,
    accountTimeZone,
    selectedRule,
    stateMgr,
    preferenceSvc,
    appCfg,
    entity,
    isEmailOption,
    instrumentation,
    isForVNext = false,
  }) {
    this.options = {
      i18n,
      permissions,
      accountTimeZone,
      selectedRule,
      stateMgr,
      preferenceSvc,
      appCfg,
      entity,
      isEmailOption,
      instrumentation,
    };
    super.initialize(this.options);
    this.i18n = i18n;
    this.isForVNext = isForVNext;
    this.renderRunOnceDatePicker();
  }

  get template() {
    return template;
  }

  get ViewModel() {
    return RuleCronSelectionviewModel;
  }

  renderRunOnceDatePicker() {
    const today = lastNDate(new Date());
    const end = todayNYearsAgo(today, -10);
    const needToUpdateDate = this.options.selectedRule.runOnceDate < today;
    const selectedDate = needToUpdateDate ?
      today :
      this.options.selectedRule.runOnceDate;

    this.runOnceDatePicker = new DatePicker({
      selectedDate,
      minDate: today,
      maxDate: end,
    });

    this.runOnceDatePicker.on('dateChanged', (newDate) => {
      if (newDate) {
        this.viewModel.startInput(this.i18n.formatDate(newDate, { timeZone: null }));
      }
    });

    if (needToUpdateDate) {
      this.runOnceDatePicker.trigger('dateChanged');
    }

    this.setChild('date-picker', this.runOnceDatePicker);
  }

  getCron() {
    return this.viewModel.getCron();
  }

  getSelectedDataDateRangeOption() {
    return this.viewModel.selectedDataDateRangeOption();
  }

  validate() {
    return this.viewModel.validate();
  }
}
